export default "__VITE_ASSET__kYS2f_Le__"